import styled from 'styled-components'

export { Container } from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/previewStyles'

export const PreviewIframe = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 800px;
  border: none;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  background-color: ${props => props.theme.colors.background.primary};
`
